import { MatchStatus, PropertyType } from '@brickup/shared/enums'
import {
  boolFilter,
  FILTER_ALL,
  oneOf,
  selectedRowFilter,
  stringFilter,
  type AllOr,
  type FilterDef,
} from '@/components/Internal/DataTable'

export type SortField =
  | 'createdAt'
  | 'livingArea'
  | 'landArea'
  | 'numberOfRooms'
  | 'listingPrice'
  | 'type'

export type SortOrder = 'asc' | 'desc'

const SORT_FIELDS: SortField[] = [
  'createdAt',
  'livingArea',
  'landArea',
  'numberOfRooms',
  'listingPrice',
  'type',
]

export const propertyListFilters = {
  search: stringFilter(),

  type: oneOf<AllOr<PropertyType>>(PropertyType, FILTER_ALL),

  // Any mandate id is acceptable — the list simply comes back empty for one
  // that no longer exists.
  customer: stringFilter<AllOr<string>>(FILTER_ALL),

  matchStatus: oneOf<AllOr<MatchStatus>>(MatchStatus, FILTER_ALL),

  customerFeedback: oneOf<AllOr<'liked' | 'disliked'>>(
    ['liked', 'disliked'],
    FILTER_ALL,
  ),

  /** The bin is a separate list, not a narrowing of this one, so resetting the
   *  filters must not tip the operator back out of it. */
  trashed: {
    ...boolFilter(),
    countsAsFilter: false,
  } satisfies FilterDef<boolean>,

  sortBy: {
    ...oneOf<SortField>(SORT_FIELDS, 'createdAt'),
    countsAsFilter: false,
  } satisfies FilterDef<SortField>,

  sortOrder: {
    ...oneOf<SortOrder>(['asc', 'desc'], 'desc'),
    countsAsFilter: false,
  } satisfies FilterDef<SortOrder>,

  /** The row whose detail sidebar is open. Survives a filter reset. */
  selected: selectedRowFilter(),
}
